import React from 'react';
import { Typography } from '@material-ui/core';

export const FormReviewComponent = () => (
  <div>
    <Typography variant="subtitle1">*Disclaimer</Typography>
    <Typography variant="caption" component="div">
      This form will be publicly accessible.
      Any person who receives or accesses the URL
      to this form will be able to submit events
      into your organization based on the workflows
      you selected.
    </Typography>
    <Typography variant="caption" component="div">
      This is the only access to your Pingum organization and
      data they will have. All other data in your
      organization will remain private and only accessible to
      users added to your Pingum organization.
    </Typography>
  </div>
);

FormReviewComponent.propTypes = { };
FormReviewComponent.defaultProps = { };

export default FormReviewComponent;
